<template>
  <div v-if="enableNodes">
    <K8ClusterNodeOverview
      :height="'40rem'"
      :tableConfigs="nodeOverviewConfig"
      :mapConfigs="chartConfig"
    />
  </div>
  <div v-else>
    <div class="k8m-overview-table-chart-element" v-if="getTableConfig">
      <TableBuilder
        :tableConfig="getTableConfig"
        :scope="scope"
        :height="'40rem'"
        :enableInfiniteScroll="true"
        :maxPageSize="10"
        :defaultSortKey="getDefaultSortKey"
      />
    </div>
  </div>
</template>
<script>
import K8ClusterNodeOverview from '@/components/K8M/Cluster/ClusterNodeOverview.vue';
import TableBuilder from '@/components/K8M/Common/TableBuilder.vue';
import {
  configTableMap,
  K8NodeOverviewConfig,
} from '@/components/K8M/Cluster/cluster.table.config';
import { k8mNodeGraphs } from '@/components/K8M/Node/nodes.graph.config';
import { k8Scopes } from '@/store/modules/k8/k8-types';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';
import { K8RoutesConfig, K8Routes } from '@/components/K8M/k8.types';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'K8MOverviewTable',
  components: {
    TableBuilder,
    K8ClusterNodeOverview,
  },
  data() {
    return {
      scope: k8Scopes.SERVICE,
      searchData: [],
      chartConfig: k8mNodeGraphs.lineCharts,
    };
  },
  computed: {
    ...mapState('k8State/k8CommonState', ['currentCluster']),
    getTableConfig() {
      return configTableMap?.[this.$route.name]()?.[0];
    },
    enableNodes() {
      return this.$route.name === K8Routes.nodes;
    },
    getDefaultSortKey() {
      return this.getTableConfig?.defaultSortKey;
    },
    nodeOverviewConfig() {
      return K8NodeOverviewConfig();
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setUpdateDasboard']),
    ...mapMutations('k8State/k8CommonState', [
      'setCurrentK8Tab',
      'setCurrentRouteConfig',
    ]),
    setTemplate() {
      this.setCurrentK8Tab(this.$route?.meta?.tab);
    },
    getChildRoutes(routes) {
      return routes.filter((item) => item.name !== this.$route.name);
    },
    getPath(routename) {
      return K8RoutesConfig.filter((item) => item.name === routename);
    },
  },
  watch: {
    'currentCluster.key'() {
      this.setUpdateDasboard(this.currentCluster);
    },
    '$route.name'() {
      this.setCurrentRouteConfig([
        {
          name: 'k8mCluster',
          path: 'clusterOverview',
          breadcrumbName: 'Cluster',
        },
        {
          name: this.$route.name,
          path: this.getPath(this.$route.name)[0].path,
          breadcrumbName: this.getPath(this.$route.name)[0].breadcrumbName,
          children: this.getChildRoutes(K8RoutesConfig),
        },
      ]);
    },
  },
  mounted() {
    this.setTemplate();
    this.setCurrentRouteConfig([
      {
        name: 'k8mCluster',
        path: 'clusterOverview',
        breadcrumbName: 'Cluster',
        tab: K8_NAVTABS.K8M_CLUSTER_TAB,
      },
      {
        name: this.$route.name,
        path: this.getPath(this.$route.name)[0].path,
        breadcrumbName: this.getPath(this.$route.name)[0].breadcrumbName,
        tab: this.$route?.meta?.tab,
        children: this.getChildRoutes(K8RoutesConfig),
      },
    ]);
  },
};
</script>

<style lang="scss" scoped>
:deep(.toggle) {
  margin-left: auto;
  margin-right: 1rem;
}
.k8m-overview-table-chart-element {
  width: 100%;
  margin-bottom: 1.5rem;
  margin-top: 0.125rem;
  margin-left: 0.125rem;
}
</style>
